import React, {useEffect, useRef} from "react";
import "./VolumeLevelControl.scss";

export default ({muted, volume, onChange}) => {
    const sliderRef = useRef(null);

    const handleDragStart = (e) => {
        addDragEvents();
        handleDragMove(e);
    }
    const handleDragMove = (e) => {
        const sliderRect = sliderRef.current.getBoundingClientRect();
        let position = (e.pageX - sliderRect.left) / sliderRect.width;
        if (position < 0) {
            position = 0;
        } else if (position > 1) {
            position = 1;
        }

        onChange(position);
    }
    const handleDragStop = () => {
        removeDragEvents();
    }

    const addDragEvents = () => {
        window.addEventListener('mousemove', handleDragMove);
        window.addEventListener('mouseup', handleDragStop);
    }
    const removeDragEvents = () => {
        window.removeEventListener('mousemove', handleDragMove);
        window.removeEventListener('mouseup', handleDragStop);
    }

    useEffect(() => {
        return removeDragEvents;
    }, []);

    const className = 'stream-player-volume-slider';

    if (muted) {
        return null;
    }

    return (
        <div className={className} ref={sliderRef} onMouseDown={handleDragStart}>
            <div className={`${className}-track`}>
                <div className={`${className}-fill`} style={{width: (volume * 100 + '%')}}>
                    <div className={`${className}-point`} />
                </div>
            </div>
        </div>
    );
}
